<template>
    <div class="container">
        <dis_tabs></dis_tabs>
        <div class="wrap mt15 flex">
            <div class="flex0 bg_fff pt15 pb15 width30">
                <dis_filter @change="change"></dis_filter>
                <!--<online-list :list="list" @list-click="doOnlineAction"></online-list>-->
                <dis_online_list :list="list" @list-click="doOnlineAction"></dis_online_list>
            </div>
            <div class="flex0 width40 bg_fff flex middle ">
                <!--<online-pat-info :info="currOrder" class="flex1" @btn-click="doOnlineAction"></online-pat-info>-->
                <dis_pat_info class="flex1" :info="currOrder" @btn-click="doOnlineAction"></dis_pat_info>
            </div>
            <div class="flex0 width28 bg_fff">
                <dis_online_videos :room-id="room.roomNo" :info="currOrder" ref="video" @openBank="openBank"></dis_online_videos>
            </div>
            <recipe-dialog ref="recipe"  type="online"
                           @handler="(name,type)=>{doOnlineAction(name,currOrder,type)}"></recipe-dialog>
            <dis_diagnose_report ref="report" :info="currOrder" @btn-click="doOnlineAction"></dis_diagnose_report>
            <consultation-bank-dialog  ref="whiteBank"></consultation-bank-dialog>
        </div>
    </div>
</template>

<script>
    import dis_tabs from "../../components/dis/dis-tabs";
    import dis_filter from "../../components/dis/dis-filter";
    import dis_online_list from "../../components/dis/dis-online-list"
    import dis_pat_info from "../../components/dis/dis-pat-info"
    import dis_diagnose_report from "../../components/dis/dis-diagnose-report"
    import {OnlineMixin} from "../../lib/mixins/online";
    import OnlineList from "../../components/online/list";
    import OnlinePatInfo from "../../components/online/pat-info";
    import OnlineVideos from "../../components/online/videos";
    import {isEmpty, timeFormat} from "../../lib/utils";
    import {onlineService} from "../../lib/service/online";
    import {tee3getRoom,tee3LeaveRoom} from "../../lib/video/tee3";
    import RecipeDialog from "../../components/online/recipe-dialog";
    import {disService} from "../../lib/service/dis"
    import {mapMutations,mapState} from 'vuex'
    import {disDocCache,disDepCache,disTypeCache} from '../../lib/cache/DisOrder'
    import dis_online_videos from '../../components/dis/dis-online-videos'
    import ConsultationBankDialog from "../../components/consultation/bank-dialog"
    export default {
        name: "receive",
        data() {
            return {
                list: [],
                page: 1,
                roomInfo: {},
                currOrder: {},
                bindDocList:[],
                bindDepList:[],
                form:{},
                timer:null
            }
        },
        computed: {
            ...mapState(["currentBindDoc"]),
            room() {
                return this.roomInfo.room || {};
            }
        },
        components: {RecipeDialog, dis_online_list, dis_filter, dis_tabs,dis_pat_info,dis_diagnose_report,dis_online_videos,ConsultationBankDialog},
        watch: {
            form: {
                handler() {
                    this.queryTodayReceiveList();
                },
                deep: true
            }
        },
        methods: {
            ...mapMutations(['setCurrentBindDocLists','setCurrentBindDepLists','setCurrentBindDoc','setCurrentBindDep']),
            change(data) {
                this.form = data;
            },
            getOnlineActionMap() {
                return new Map([
                    ['接诊', async (order) => {
                        this.$confirm('是否确认接诊患者？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                        }).then(async () => {
                            //this.$refs.video.enterRoom();
                            //await this.getInfo(order.ddid);
                            const obj = await disService.enterRoom({outpatientId:order.ddid});
                            const detail = await disService.queryDetail({outpatientId:order.ddid});
                            detail.ksmc = order.ksmc;
                            this.currOrder = detail;
                            this.roomInfo = obj;
                            await this.intoVideo();
                        }).catch(() => {

                        });
                    }],
                    ['提醒进入诊间', async (order) => {
                        if (await disService.bellPat(order.ddid)){
                            this.$message({
                                showClose: true,
                                message: '已经发送提醒短信',
                                type: 'success'
                            });
                        }
                    }],
                    ['提醒取号', async (order) => {
                        if (await disService.bellGetNum(order.ddid)){
                            this.$message({
                                showClose: true,
                                message: '已经发送提醒短信',
                                type: 'success'
                            });
                        }
                    }],
                    ['查看资料', async (order) => {
                        const obj = await disService.queryDetail({
                            outpatientId:order.ddid
                        });
                        obj.ksmc = order.ksmc;
                        this.currOrder = obj;
                    }],
                    ['结束问诊', async order => {
                        this.$confirm('是否结束问诊？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                        }).then(async () => {
                            await disService.getNum({
                                "orderId":order.id,
                                "hosId":order.bookHosId,
                                "orderState":"1"
                            });//取号 和 取消问诊是同一个接口
                            if (await disService.endOrder(order.id)) {
                                this.$message({
                                    showClose: true,
                                    message: '您已经结束问诊',
                                    type: 'success'
                                });
                                this.$refs.video.leaveRoom();
                                this.$refs.video.clearTimer();
                                this.queryTodayReceiveList();
                                this.currOrder = {};
                            }
                        }).catch(() => {
                        });
                    }],
                    ['诊疗记录',() => {
                        this.$refs["report"].showReport();
                    }],
                    ['修改诊疗记录',async (form) => {
                        if (await disService.save(form)) {
                            this.$message({
                                showClose: true,
                                message: '保存成功',
                                type: 'success'
                            });
                            const obj = await disService.queryDetail({outpatientId:form.outpatientId});
                            obj.ksmc = form.ksmc;
                            this.currOrder = obj;
                        }
                    }]
                ]);
            },
            doOnlineAction(name, order, type) {
                console.log('name', name, order);
                const map = this.getOnlineActionMap();
                //如果order为空不作任何反应
                if (Object.keys(order).length === 0) return
                const action = [...map].find(([key]) => key === name);
                action[1](order, type);
            },

            async getInfo(id) {
                this.currOrder = await onlineService.info(id)
            },

            async intoVideo() {
                const {room} = this.roomInfo;
                if (!isEmpty(room)) {
                    this.$refs.video.enterRoom();
                }
            },

            async getData() {
                const {bookHosId, bookDocId, mzlb} = this.form;
                this.list = [];
                if (!isEmpty(bookDocId) && !isEmpty(bookHosId)) {
                    const date = timeFormat(Date.now(), '%Y-%m-%d');
                    const {obj} = await onlineService.list({
                        hosid: bookHosId,
                        ysid: bookDocId,
                        date,
                        orderType: mzlb === '2' ? '1' : undefined,
                        bdate: date,
                        edate: date,
                        pageSize: 10000
                    });
                    if (obj.code === '0') {
                        this.list = obj.list;
                    }
                    /*const list = await onlineService.list2({
                      hosid: bookHosId,
                      ysid: bookDocId,
                      date,
                      orderType: mzlb === '2' ? '1' : undefined,
                      bdate: date,
                      edate: date,
                      pageSize: 100001
                    });
                    this.list = list;*/
                }
            },
            //获取绑定医生列表
            async getBindDocList(id){
                let list = await  disService.getBindDoc({
                    docId:id
                })
                if(list.length > 0){
                    this.getDep(list);
                    let docs = []
                    list.forEach(item=>{
                        if (item.bookDocId){
                            docs.push(item)
                        }
                    })
                    this.setCurrentBindDocLists(docs);//将挂号医生列表防区vuex
                    if(isEmpty(disDocCache.get())){
                        disDocCache.set(docs[0]);
                        this.setCurrentBindDoc(docs[0]);
                    }else{
                        this.setCurrentBindDoc(disDocCache.get());
                    }

                    if(isEmpty(disTypeCache.get())){
                        this.form = {
                            bookHosId:docs[0].bookHosId,
                            bookDepId:docs[0].bookDeptId,
                            bookDocId:docs[0].bookDocId,
                            depKind:"1"
                        }
                    }else{
                        if(disTypeCache.get() == "1"){
                            this.form = {
                                bookHosId:disDocCache.get().bookHosId,
                                bookDepId:disDocCache.get().bookDeptId,
                                bookDocId:disDocCache.get().bookDocId,
                                depKind:"1"
                            }
                        }else{
                            this.form = {
                                bookHosId:disDepCache.get().bookHosId,
                                bookDepId:disDepCache.get().bookDeptId,
                                depKind:"2"
                            }
                        }
                    }

                }else{
                    this.$message.error('未关联挂号医生');
                }
            },
            //区别医生列表和科室列表
            getDep(lists){
                let list = []
                lists.forEach(item=>{
                    if (item.bookDocId){
                        list.push(item)
                    }
                })
                let dom = [];
                let depList = [];
                for(let obj of list){
                    if(dom.indexOf(obj.bookDeptId) == -1){
                        depList.push({
                            bookDeptId:obj.bookDeptId,
                            bookDeptName:obj.bookDeptName,
                            bookHosId:obj.bookHosId,
                            bookHosName:obj.bookHosName
                        });
                    }
                }
                this.setCurrentBindDepLists(depList);
                if(isEmpty(disDepCache.get())){
                    disDepCache.set(depList[0]);
                    this.setCurrentBindDep(depList[0]);
                }else{
                    this.setCurrentBindDep(disDepCache.get());
                }
            },
            //查询当日接受列表
            async queryTodayReceiveList(){
                if(this.timer == null){
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                const formTel = {
                    orderType:"1",
                    pageNum:"1",
                    pageSize:"1000"
                }
                if(this.form.depKind == "1"){
                    formTel.bookHosId = this.form.bookHosId;
                    formTel.bookDeptId = this.form.bookDepId;
                    formTel.bookDocId = this.form.bookDocId;
                }else{
                    formTel.bookHosId = this.form.bookHosId;
                    formTel.bookDeptId = this.form.bookDepId;
                }
                const {obj} = await disService.queryReceiveList(formTel);
                this.list = obj.list;
                this.timer = setTimeout(this.queryTodayReceiveList,60000);
            },
            //处理数据
            merge(l1,l2){
                let returnArr = [];
                for(let o of l1){
                    let order = l2.find(val => {
                        return o.ddid == val.id
                    })
                    let obj = Object.assign({},o,order);
                    returnArr.push(obj);
                }
                return returnArr
            },
            openBank(){
                this.$refs['whiteBank'].show();
            }
        },
        async created() {
            const {doc} = this.loginInfo;//获取当前医生信息
            await this.getBindDocList(doc.id);//获取绑定医生列表
        },
        destroyed() {
            clearTimeout(this.timer);
            //自动离开视频房间并且关闭摄像头
            if(!isEmpty(tee3getRoom())){
                tee3LeaveRoom();
            }
        }
    }
</script>
<style scoped lang="scss">
    .middle {
        margin-right: 1%;
        margin-left: 1%;
    }
</style>

